/**
 * DesignerNode Constants
 *
 * Grid configuration and default values for the designer canvas.
 */

// Grid dimensions
export const DEFAULT_GRID_COLS = 12;
export const DEFAULT_GRID_ROWS = 8;
export const DEFAULT_CELL_WIDTH = 60;
export const DEFAULT_CELL_HEIGHT = 60;

// Drag activation (prevents accidental drags)
export const ACTIVATION_DISTANCE = 5; // pixels

// Minimum element size (in grid units)
export const MIN_COL_SPAN = 1;
export const MIN_ROW_SPAN = 1;

// Grid visual styling
export const GRID_LINE_COLOR = 'rgba(99, 102, 241, 0.08)';
export const GRID_LINE_COLOR_MAJOR = 'rgba(99, 102, 241, 0.15)';
